import kebabCase from 'lodash-es/kebabCase'
import React from 'react'

import * as S from './styled'
import type { TabPillsItemProps } from './types'

export const TabPillsItem = ({
  appearance,
  size = 'medium',
  label,
  active,
  onClick,
}: TabPillsItemProps) => (
  <S.Tab
    key={kebabCase(label)}
    $appearance={appearance}
    $size={size}
    $active={active}
    onClick={onClick}
  >
    {label}
  </S.Tab>
)
